import {createReducer} from '@reduxjs/toolkit';
import {
    getManagers,
    updateManagers,
    getPositions,
    getRelations,
    createRelation,
    deleteRelation,
    getProfiles
} from '../actions';
import {ProfileDto} from '../../../../dto/ProfileDto';
import {SettingsRelationDto} from '../../../../dto/RelationDto';

type InitialState = {
    profiles: ProfileDto[];
    managers: ProfileDto[];
    positions: string[];
    relations: SettingsRelationDto[];
};

const initialState: InitialState = {
    profiles: [],
    managers: [],
    positions: [],
    relations: []
};

export const projects = createReducer(initialState, (builder) =>
    builder
        .addCase(getManagers.fulfilled, (state, action) => ({...state, managers: action.payload}))
        .addCase(updateManagers.fulfilled, (state, action) => ({...state, managers: action.payload}))
        .addCase(getPositions.fulfilled, (state, action) => ({...state, positions: action.payload}))
        .addCase(getRelations.fulfilled, (state, action) => ({...state, relations: action.payload}))
        .addCase(createRelation.fulfilled, (state, action) => ({
            ...state,
            relations: state.relations.concat(action.payload)
        }))
        .addCase(deleteRelation.fulfilled, (state, action) => ({
            ...state,
            relations: state.relations.filter(({relationId}) => relationId !== action.payload)
        }))
        .addCase(getProfiles.fulfilled, (state, action) => ({...state, profiles: action.payload}))
);
